

export enum SurveyAssessment {
    SURVEY = 'SURVEY',
    ASSESSMENT = 'ASSESSMENT'
}